<svelte:options tag={null} />
<script lang="ts">
  import { get_current_component } from "svelte/internal";
  import "@everymatrix/em-accordion";

  export let currency = 'EUR';
  export let success = false;
  export let error;
  let validationError;
  const initalLimits = [
    {
      period: 'Daily',
      amount: 0,
      checked: false
    },
    {
      period: 'Weekly',
      amount:0,
      checked: false,
    },
    {
      period: 'Monthly',
      amount: 0,
      checked: false
    }
  ]

  let limits = [...initalLimits]
  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  const handleData = (list: any[]) => {
    validationError = null;
    let selectedLimits = list.filter(limit => limit.checked && limit.amount) 
    if (selectedLimits.length < 1) {
      validationError = "Must have atleast a period checked";
      return;
    }
    selectedLimits = selectedLimits.map(limit => {
      delete limit.checked
      limit.currency = currency
      return limit
    }) 
      // Reset Selections
    limits = [...initalLimits]
    // Send Custom Event
    dispatchWcEvent("change", { "lossLimits": selectedLimits });
    
  };

</script>


<div class="accordion">
  <em-accordion>
    <!-- Title -->
    <h3 slot="title" class="accordion__title">
      Loss Limit
    </h3>
    <!-- Content -->
    <div slot="content" class="accordion__content">
      {#each limits as limit, index}
        <!-- Limit Name -->
        <label class="selectWrapper">
          <input
            class="checkbox"
            type=checkbox
            bind:checked={limit.checked}
            value="{limit.period}"
          >
          <span>
            {limit.period}
          </span>
        </label>
        <!-- Limit Input -->
        {#if limit.checked}
          <label class="inputWrapper">
            <input
              class="input"
              type="number" 
              name="depositAmount"
              bind:value="{limit.amount}"
            >
            <span>{currency}</span>
          </label>
        {/if}
      {/each}

      {#if validationError}
        <p style="color: red;">
          {validationError}
        </p>
      {/if}
      {#if success?.hasOwnProperty('lossLimit')}
        <p style="color: green;">
          Limit saved succesfully
        </p>
      {/if}
      {#if error && error.includes('LossLimit')}
        <p style="color: red;">
          {error.slice(0, 20)}
        </p>
      {/if}
      <!-- Save Button -->
      <button
        class="button" 
        on:click={() => handleData(limits)}
      >
        Save
      </button>
    </div>
  </em-accordion>
</div>


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }
  .accordion {
    margin-bottom: 10px;

    &__content {
      display: flex;
      flex-direction: column;
    }
  }

  .selectWrapper {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    cursor: pointer;
    &:last-child { margin-bottom: 0; }
    span { 
      margin-left: 10px;
      font-size: 12px;
    }
  }

  .inputWrapper {
    margin-bottom: 10px;
    span { font-weight: bold; }
  }

  .input {
    max-width: 50%;
    padding: 5px 10px;
    margin-right: 10px;
  }

  .button {
    display: block;
    width: 150px;
    margin: 20px auto 0 auto;
    min-height: 30px;
    padding: 6px 7px;
    color: #fff;
    background: #307fe2;
    border: 1px solid #307fe2;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 16px;
    &:hover {
      background: #000;
      border: 1px solid #000;
    }
  }
</style>
